<template lang="html">
  <section class="hit-calculator-checkboxes-included-settings settings">
    <header>
      <h1 class="page-header">Hit calculator checkboxes included</h1>
    </header>
    <!-- made hands -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-8 col-sm-6">Made hand</th>
          <th class="col-xs-2 col-sm-3">Included</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="madeHandLeaf in madeHandLeaves">
          <td v-html="madeHandLeaf.breadcrumbText"></td>
          <td><input v-model="includedByDefault[madeHandLeaf.id]" type="checkbox"></td>
        </tr>
      </tbody>
    </table>

    <!-- draws -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-8 col-sm-6">Draw</th>
          <th class="col-xs-2 col-sm-3">Included</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="drawLeaf in drawLeaves">
          <td v-html="drawLeaf.breadcrumbText"></td>
          <td><input v-model="includedByDefault[drawLeaf.id]" type="checkbox"></td>
        </tr>
      </tbody>
    </table>

    <!-- combos -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-8 col-sm-6">Combo</th>
          <th class="col-xs-2 col-sm-3">Included</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="comboLeaf in comboLeaves">
          <td v-html="comboLeaf.breadcrumbText"></td>
          <td><input v-model="includedByDefault[comboLeaf.id]" type="checkbox"></td>
        </tr>
      </tbody>
    </table>

    <hr>
    <section class="buttons">
      <button class="btn btn-default btn-lg" v-on:click="isHelpVisible = !isHelpVisible">
        <span v-if="!isHelpVisible">Show help <span class="caret-down"></span></span>
        <span v-if="isHelpVisible">Hide help <span class="caret-up"></span></span>
      </button>
      <button class="btn btn-default btn-lg" v-on:click="reset()">
        Set to defaults
      </button>
      <button class="btn btn-primary btn-lg" v-on:click="save()">
        Save
      </button>
    </section>
    <section v-if="isHelpVisible" class="well">
      <p>If you feel like the hit calculator is cluttered and you aren't interested in some of the checkboxes, you may want to uninclude some of them.</p>
      <hr>
      <img src="/static/settings/hit-calculator-checkboxes-included-1.png">
      <img src="/static/settings/hit-calculator-checkboxes-included-2.png">
    </section>
  </section>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'hit-calculator-checkboxes-included-settings',
  data: function () {
    return {
      includedByDefault: _.cloneDeep(this.$store.state.account.user.settings.hitCalculator.includedByDefault),
      isHelpVisible: false,
    };
  },
  computed: {
    madeHandLeaves: function () {
      let fiveCardHands = new FiveCardHands();

      return fiveCardHands.madeHands.flatArrayOfLeaves;
    },
    drawLeaves: function () {
      let fiveCardHands = new FiveCardHands();

      return fiveCardHands.draws.flatArrayOfLeaves;
    },
    comboLeaves: function () {
      let fiveCardHands = new FiveCardHands();

      return fiveCardHands.combos.flatArrayOfLeaves;
    },
    defaultIncludedByDefault: function () {
      let defaultIncludedByDefault = {};

      this.madeHandLeaves.forEach(function (madeHandLeaf) {
        defaultIncludedByDefault[madeHandLeaf.id] = true;
      });
      this.drawLeaves.forEach(function (drawLeaf) {
        defaultIncludedByDefault[drawLeaf.id] = true;
      });
      this.comboLeaves.forEach(function (comboLeaf) {
        defaultIncludedByDefault[comboLeaf.id] = true;
      });

      return defaultIncludedByDefault;
    },
  },
  methods: {
    save: function () {
      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.includedByDefault = this.includedByDefault;
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    reset: function () {
      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.includedByDefault = this.defaultIncludedByDefault;
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        self.madeHandLeaves.forEach(function (madeHandLeaf) {
          self.includedByDefault[madeHandLeaf.id] = true;
        });
        self.drawLeaves.forEach(function (drawLeaf) {
          self.includedByDefault[drawLeaf.id] = true;
        });
        self.comboLeaves.forEach(function (comboLeaf) {
          self.includedByDefault[comboLeaf.id] = true;
        });
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';

  img {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/hit-calculator/checkboxes/included.vue